import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'app-ms-clarity',
    template: '<ng-content></ng-content>',
})
export class MsClarityComponent implements OnInit {
    private clarityProjectId = environment.msClarityProjectId;
    private msClarityScript!: HTMLScriptElement

    constructor(
        private renderer2: Renderer2,
        @Inject(DOCUMENT) private doc: Document
    ) { }

    /**
     * Initializes the component by creating a script element for Microsoft Clarity
     */
    ngOnInit(): void {
        this.msClarityScript = this.renderer2.createElement("script");
        this.loadClarityScript();
    }


    /**
     * Loads the Microsoft Clarity script by setting its attributes
     * and appending it to the document head.
     */
    loadClarityScript(): void {
        if (this.clarityProjectId) {
            this.msClarityScript.setAttribute("id", "msClarityScript");
            this.msClarityScript.type = "text/javascript";
            this.msClarityScript.text = `(function(c,l,a,r,i,t,y){
            c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
            t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
            y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
        })(window, document, "clarity", "script", "${this.clarityProjectId}");`;
        }
        this.renderer2.appendChild(this.doc.head, this.msClarityScript);
    }
}
